import React from 'react';
export const Logos = () => {
  return <section className="py-16 border-y border-gray-100 bg-gray-50/50" data-id="element-790" data-mp="1vnabnpncc3rw">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-791" data-mp="50qn5u8017g7">
        <p className="text-center text-sm font-medium text-gray-500 mb-12" data-id="element-792" data-mp="2ovwm0f61tn">
          Trusted by talent agencies, brands, and marketing teams managing
          creator campaigns
        </p>

        <div className="flex flex-wrap sm:flex-nowrap items-center justify-center gap-x-6 sm:gap-x-8 gap-y-6 w-full mx-auto opacity-70 hover:opacity-100 transition-opacity duration-300 sm:overflow-x-auto" data-id="element-793" data-mp="srcj4n4qb19u">
          {[{
          name: 'Revel Interactive',
          src: 'https://cdn.magicpatterns.com/uploads/vwR87fB6Bn4pAzrayBkBki/Screenshot_2026-07-07_at_23.37.33.png'
        }, {
          name: 'ARCH',
          src: 'https://cdn.magicpatterns.com/uploads/o6ETMSDceFvkG57zERPBUV/Screenshot_2026-07-07_at_23.37.42.png'
        }, {
          name: 'Media Bodies',
          src: 'https://cdn.magicpatterns.com/uploads/9iNGp7Ccn5kabRrP3PnZ1K/Screenshot_2026-07-07_at_23.37.46.png'
        }, {
          name: 'Hype Artists Agency',
          src: 'https://cdn.magicpatterns.com/uploads/jnRgufmW9LQ8Jesf76L8Km/Screenshot_2026-07-07_at_23.37.50.png'
        }, {
          name: 'Viral Nation',
          src: 'https://cdn.magicpatterns.com/uploads/nS6bvUCnHZ2ttav1w6X8Wd/Screenshot_2026-07-07_at_23.37.58.png'
        }, {
          name: 'Raymond Representation',
          src: 'https://cdn.magicpatterns.com/uploads/eLcHv5T4WAjfHrDBnrY1L5/Screenshot_2026-07-07_at_23.37.24.png'
        }, {
          name: 'Clicks Talent',
          src: 'https://cdn.magicpatterns.com/uploads/56JhbDyWQd6Y6GyfgN3DUt/Screenshot_2026-07-07_at_23.37.29.png'
        }, {
          name: 'UTA',
          src: 'https://cdn.magicpatterns.com/uploads/p6rZnUxExy63ijJThjE2jt/uta_logo_small.jpg'
        }].map(logo => <img key={logo.name} src={logo.src} alt={`${logo.name} on Zano`} className="h-7 sm:h-9 w-auto object-contain mix-blend-multiply shrink-0" data-id="element-794" data-mp="14cysws7h3yt5" />)}
        </div>
      </div>
    </section>;
};